import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import type { Feedback } from "../lib/api";

interface FeedbackTableProps {
  feedback: Feedback;
}

export default function FeedbackTable({ feedback }: FeedbackTableProps) {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell width={200}>
            <b>Item</b>
          </TableCell>
          <TableCell>Message</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {feedback.items.map(({ name, message }) => (
          <TableRow key={name}>
            <TableCell width={200}>
              <b>{name}</b>
            </TableCell>
            <TableCell style={{ color: "red" }}>{message}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
